const UI = "interface.do";

export default {
  CE: "/rest/ce",
  SIGNATURE: "/rest/signature",
  ACQUISITION: "/rest/acquisition",
  IDENTIFIER: "/rest/identifier",
  OCM: "/rest/ocm",
  EDIT_LOCATION: "editLocation.do",
  MAP_CONFIG: "/rest/mapConfig",
  BUILT_ENVIRONMENT_SITE: "/rest/builtEnvironmentSite",
  SEARCH_RESULTS: "searchResultsREST.do",
  DISPLAY_OBJECT: "displayObjectREST.do",
  ACCESSRIGHTS: "accessRightsREST.do",

  UI: {
    DISPLAY_RESOURCE: UI + "?displayResource=true",
    DISPLAY_RESOURCE_VALUE: UI + "?displayResourceValue=true",
    EDIT_RESOURCE: UI + "?editResource=true",
    CREATE_RESOURCE: UI + "?createResource=true",
    GET_TEMPLATE: UI + "?getObjectTemplate=true",
    NAMED_TEMPLATE: UI + "?namedTemplate=true",
    TEMPLATE_OPTIONS: UI + "?templateOptions=true",
    DISPLAY_OBJECT: UI + "?displayObject=true",
    EDIT_OBJECT: UI + "?editObject=true",
    CREATE_OBJECT: UI + "?createObject=true",
    MASS_EDIT: UI + "?massEdit=true",
    MASS_EDIT_RESTRICTION: UI + "?hasMassEditRestriction",
    IMPORTANT_INFO: 'displayObjectREST.do?important',
    MAX_OCCURS_UNLIMITED: UI + "?maxOccursUnlimited=true",
    REPORT_ERROR: UI + "?uiError=true",
    ENUM: UI + "?enum=true",
    ENUMS: UI + "?enums=true",
    RELOAD_CONFIG: UI + "?editResource=true",
    SEARCH_RESULTS: UI + "?searchResults=true",
    REPORT_TEMPLATE: UI + "?reportTemplate=true",
    CALENDAR: "/rest/calendar",
    HELP_MESSAGES: "/rest/admin/helpMessages",
  },

  DAM: {
    SUGGESTIONS: "suggestions.do",
    COPY_OBJECT: "copyitem.do",
    INDEX: "index.do",
    ADD_CONTENT: "addContent.do",
    DISPLAY_OBJECT: "displayObject.do",
    EDIT_OBJECT: "editObject.do",
    EDIT_RESOURCE: "editResourceObject.do",
    EDIT_DIGITAL_CONTENT: "editDigitalContent.do",
    CREATE_OBJECT: "createArchivedObject.do",
    MASS_EDIT: "editMultipleObjects.do",
    NAMED_TEMPLATE: "namedMetadataTemplate.do",
    DISPLAY_FOLDER: "displayFolder.do",
    DISPLAY_CONTENT: "displayContent.do",
    DISPLAY_ATTACHMENT: "displayContent.do?disposition=attachment&type=master",
    LINK_OBJECT: "linkArchivedObject.do",
    LINK_SEARCH: "linkSearch.do",
    VISIBILITY: "fieldVisibility.do",
    MANAGE_GROUPS: "manageUsers.do",
  },
};
